import React, { useEffect, useState } from "react";
import "./index.scss";
import { Dropdown, Offcanvas } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { home, profile } from "../../utils/router/constant";
import { useSelector } from "react-redux";
import { getCustomerInfo } from "../../service/proposal/proposalService";
import { getAgDetailsByBaseUrl } from "../../service/commonService";
import Logout from "../../auth/logout";
import {
  AccountIcon,
  Logo,
  LogoutDrawerIcon,
  MenuBarIcon,
} from "../../assets/images/svg/svg";
import TabWidget from "../../components/tabWidget";
import {
  clearExistingToken,
  getCodeFromUrl,
  getNameAbbrevation,
  handleConditionalRedirect,
} from "../../utils/helper";
import { AG_CODE } from "../../utils/commonConstant";

function Header() {
  const nav = useNavigate();
  const customerData = useSelector((state) => state.common.customerData);
  const [show, setShow] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const handleMenu = () => setShowMenu(!showMenu);

  const handleLogoutClick = () => {
    setShowMenu(false);
    setShow(!show);
  };
  const handleDropdownToggle = () => setIsDropdownOpen((prev) => !prev);
  const handleDropdownOpen = () => setIsDropdownOpen(true);
  const handleDropdownClose = () => setIsDropdownOpen(false);
  let agCode = getCodeFromUrl()
  const agDetails = useSelector((state) => state.common.agDetails);
  useEffect(() => {
    getCustomerInfo();
    // agDetails (profile_enabled) is only loaded on login; reload after a refresh
    if (!agDetails?.entityid) getAgDetailsByBaseUrl(agCode).catch(console.error);
  }, []);

  return (
    <header className="header--area">
      <div className="max--container">
        <div className="header--container">
          <div 
            className="header--logo"
            onClick={() =>
              handleConditionalRedirect(customerData?.return_url, home, nav)
            }
          >
            {agCode === AG_CODE || agCode === "chem" ? (
              <Logo />
            ) : (
              <img
                src={customerData.agsa_logo_media_url}
                alt="Logo"
              />
            )}
          </div>
          <div className="header--content">
            {customerData.ag_logo_media_url && (
              <>
                {/* <div className="header--logo ag--logo">
                  <img
                    src={customerData.ag_logo_media_url}
                    alt="Logo"
                    onClick={() =>
                      handleConditionalRedirect(customerData?.return_url, home, nav)
                    }
                  />
                </div>
                <div className="header--divider"></div> */}
                <h2 className="header--title">
                  <strong>{customerData.ag_name}</strong>
                </h2>
              </>
            )}
            <div className="header--user--wrapper">
              {/* <div className="header--notification">
                <img src={NotificationImage} alt="Notification" />
              </div> */}
              <div className="header--logo ag--logo">
                <img
                  src={customerData.ag_logo_media_url}
                  alt="Logo"
                  onClick={() =>
                    handleConditionalRedirect(
                      customerData?.return_url,
                      home,
                      nav,
                    )
                  }
                />
              </div>
              {/* <div className="header--divider"></div> */}
              <div
                className="header--user--content"
                onMouseEnter={handleDropdownOpen}
                onMouseLeave={handleDropdownClose}
              >
                <Dropdown show={isDropdownOpen}>
                  <Dropdown.Toggle
                    as="div"
                    id="dropdown-basic"
                    onClick={handleDropdownToggle}
                  >
                    <div className="header--avatar">
                      {getNameAbbrevation(customerData.name)}
                    </div>
                    <div className="header--user-detail">
                      <h2 className="header--user--name">
                        {customerData.name}
                      </h2>
                      <h4 className="header--user--designation">
                        {customerData.role}
                      </h4>
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <p className="dropdown-title">
                      {customerData.name
                        ? `Welcome ${customerData.name}`
                        : "Welcome"}
                    </p>
                    <Dropdown.Item
                      onClick={() =>
                        handleConditionalRedirect(
                          customerData?.return_url,
                          profile,
                          nav,
                        )
                      }
                    >
                      <AccountIcon /> My Profile
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => handleLogoutClick()}>
                      <LogoutDrawerIcon /> Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <button
                className="header--menu__bar"
                onClick={() => handleMenu()}
              >
                <MenuBarIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Logout handleLogoutClick={handleLogoutClick} show={show} />
      <Offcanvas
        show={showMenu}
        onHide={handleMenu}
        placement="end"
        className="menu--sidebar"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <MenuBarIcon />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body closeButton>
          <TabWidget handleLogoutClick={handleLogoutClick} show={show} />
        </Offcanvas.Body>
      </Offcanvas>
    </header>
  );
}

export default Header;
